
<template>
  <ImageTeaser class="contact" :footerContactFormIsVisible="contactFormIsVisible">
    <template v-slot:image>
      <div
        class="footer-contact-image"
        alt=""
      />
    </template>

    <!-- Default slot -->
    <div class="contact-box" v-if="!contactFormIsVisible && !isCurrentLocaleGerman">
      <h2>{{ $t("general.contact") }}</h2>
      <h3 lang="en">{{ $t("contactForm.companyName") }}</h3>
      <address v-html="$t('contactForm.address')"></address>
      <p>
        {{ $t("footerContact.openingHours") }}<br />
        {{ $t("footerContact.mondayToFriday") }}<br />
        {{ $t("footerContact.time") }}
      </p>
        <address>
          {{ $t("footerContact.telephone") }}
          <a :href="'tel:' + $t('footerContact.phoneNumber')">{{ $t("footerContact.phoneNumber") }}</a>
        </address>
      <RhButton
        :value="$t('footerContact.establishContact')"
        priority="ghost"
        @click="$navigateTo('contact')"
        v-if="$route.name !== 'contact'"
      />
    </div>
    <div class="contact-box" v-if="isCurrentLocaleGerman">
      <h2>{{ $t("general.contact") }}</h2>
      <h3 lang="en">{{ $t("contactForm.companyName") }}</h3>
      <address v-html="$t('contactForm.address')"></address>
      <p>
        {{ $t("footerContact.deliveryStatusQuestion") }}
  </p>
    <a class="link2" :href="getLink()">{{ $t("footerContact.redirectLoginPage") }}</a>
    <p>
      <template v-if="hasFaqs">{{ $t("footerContact.moreQuestions") }} <a class="link2" href="/de/faq" lang="en">FAQs</a> </template>{{ $t("footerContact.contactCustomerService") }} <span lang="en">{{$t("footerContact.clientAndCustomerCareCenter")}}</span>
    </p>
      <RhButton
        :value="$t('footerContact.establishContact')"
        priority="ghost"
        @click="$navigateTo('contact')"
        v-if="$route.name !== 'contact'"
      />
    </div>
  </ImageTeaser>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ImageTeaser from "@/components/modules/ImageTeaser.vue";
import {mapGetters, mapState} from "vuex";
import { getLocale } from "@/i18n";
import { rmdFaqs } from "@/store/rmd-faq.store";

export default defineComponent({
  components: {
    ImageTeaser,
  },
   computed: {
    ...mapState([
      "order",
      "isLoggedIn",
    ]),
    ...mapGetters(["contactFormIsVisible"]),
    isCurrentLocaleGerman(): boolean {
      return getLocale() === 'de';
    },
    hasFaqs(): boolean {
      return rmdFaqs.hasFaqs(getLocale());
    },
  },
  methods:{
    getLink: function () {
      if (this.isLoggedIn)
        return 'trackandtrace';

      return '/de';
    }
  }
});

</script>

<style lang="scss" scoped>
.footer-contact-image {
  background-image: url("@/assets/photos/Rhenusmydelivery_Kontaktblock_Image.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  left: 0;
  right: 0;
  top: 40px;
  bottom: 40px;
  position: absolute;
}

@media (min-width: 1319px) {
  .footer-contact-image {
    background-size: 1319px 742px;
    background-position: center;
  }
}

.contact {
  &-box {
    & > * + * {
      margin-top: 20px;
    }

    a:focus {
      outline-color: #fff;
    }

    address {
      font-style: normal;
    }
  }
}
</style>
